import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./myapp";
import reportWebVitals from "./reportWebVitals";
import { DialogProps, SetDialogProps } from "./components/CommonDialog";
import { ConfirmDialogProps } from "./components/ConfirmDialog";
import { DrawerProps } from "./components/CommonDrawer";
import { AlertColor } from "@mui/material";
import { ToggleTabProps } from "./components/ToggleTabs";
import { PreviewDialogProps } from "./components/PreviewMediaDialog";
import { authorize } from "./actions/auth.action";
import SurveyApp from "./survey.app";

declare global {
  interface Window {
    webApp: {
      toggleDialog: <T>(param: DialogProps) => Promise<T>;
      resolve: (value?: unknown) => void;
      reject: (reason?: any) => void;
      toggleConfirmDialog: <T>(param: ConfirmDialogProps) => Promise<T>;
      setDialog: (param: SetDialogProps) => void;
      toggleDrawer: <T>(param: DrawerProps) => Promise<T>;
      showMessage: (type: AlertColor, message: string) => void;
      setTitle: (title: string) => void;
      setTab: <T>(param: ToggleTabProps) => Promise<T>;
      previewDialog: (param: PreviewDialogProps) => void;
    };
  }
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

if (process.env.REACT_APP_TYPE === "survey") {
  root.render(
    <React.StrictMode>
      <SurveyApp />
    </React.StrictMode>,
  );
} else {
  authorize().then((val) =>
    root.render(
      <React.StrictMode>
        <App logged={val} />
      </React.StrictMode>,
    ),
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
